/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/* Material icon Content Paste Search */
export const ICON_CONTENT_PASTE_SEARCH = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.20703 5.19922H6.20703V6.19922C6.20703 7.29922 7.10703 8.19922 8.20703 8.19922H14.207C15.307 8.19922 16.207 7.29922 16.207 6.19922V5.19922H18.207V10.1992H20.207V5.19922C20.207 4.09922 19.307 3.19922 18.207 3.19922H14.027C13.607 2.03922 12.507 1.19922 11.207 1.19922C9.90703 1.19922 8.80703 2.03922 8.38703 3.19922H4.20703C3.10703 3.19922 2.20703 4.09922 2.20703 5.19922V19.1992C2.20703 20.2992 3.10703 21.1992 4.20703 21.1992H9.20703V19.1992H4.20703V5.19922ZM11.207 3.19922C11.757 3.19922 12.207 3.64922 12.207 4.19922C12.207 4.74922 11.757 5.19922 11.207 5.19922C10.657 5.19922 10.207 4.74922 10.207 4.19922C10.207 3.64922 10.657 3.19922 11.207 3.19922Z"
      fill="#3D3D3D"
    />
    <path
      d="M21.507 21.0992L19.507 19.0992C20.087 18.0892 20.457 16.8692 20.017 15.4492C19.487 13.7292 17.977 12.3992 16.177 12.2292C13.307 11.9492 10.947 14.2992 11.227 17.1792C11.407 18.9692 12.727 20.4892 14.447 21.0192C15.877 21.4592 17.087 21.0892 18.097 20.5092L20.097 22.5092C20.487 22.8992 21.107 22.8992 21.497 22.5092C21.887 22.1192 21.897 21.4892 21.507 21.0992ZM15.707 19.1992C14.307 19.1992 13.207 18.0992 13.207 16.6992C13.207 15.2992 14.307 14.1992 15.707 14.1992C17.107 14.1992 18.207 15.2992 18.207 16.6992C18.207 18.0992 17.107 19.1992 15.707 19.1992Z"
      fill="#3D3D3D"
    />
  </svg>
);
